import { render, staticRenderFns } from "./CommissionCreate.vue?vue&type=template&id=c8d79c46"
import script from "./CommissionCreate.vue?vue&type=script&lang=js"
export * from "./CommissionCreate.vue?vue&type=script&lang=js"
import style0 from "./CommissionCreate.vue?vue&type=style&index=0&id=c8d79c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports